/* eslint-disable
  max-len,
  no-mixed-spaces-and-tabs,
  react/jsx-indent,
react/jsx-first-prop-new-line,
*/

import React, { PureComponent, PropTypes } from 'react';
import cn from 'classnames';

import styles from './styles.scss';

export class IpadAnimated extends PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        <svg version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 357 499.5"
          className={styles.st10}
          xmlSpace="preserve"
          preserveAspectRatio="xMinYMin slice"
        >

        <g id="Illust">
          <path className={styles.st0}
            d="M328.7,45.4c0-0.2-0.2-0.4-0.4-0.4H28.5c-0.2,0-0.4,0.2-0.4,0.4l0,0l0,0v54.5v350.2c0,0.2,0.2,0.4,0.4,0.4h299.8c0.2,0,0.4-0.2,0.4-0.4V99.9L328.7,45.4L328.7,45.4L328.7,45.4z"
          />
          <g>
            <path className={styles.st1}
              d="M178.4,483c-6.3,0-11.4-5.1-11.4-11.4s5.1-11.4,11.4-11.4c6.3,0,11.4,5.1,11.4,11.4C189.8,477.9,184.7,483,178.4,483z"
            />
          </g>
          <g>
            <g>
              <path className={styles.st2}
                d="M328.7,450.1c0,0.2-0.2,0.4-0.4,0.4H28.5c-0.2,0-0.4-0.2-0.4-0.4V45.4c0-0.2,0.2-0.4,0.4-0.4h299.8c0.2,0,0.4,0.2,0.4,0.4L328.7,450.1L328.7,450.1z"
              />
            </g>
          </g>
          <g>
            <rect x="28.1" y="426.3" className={styles.st3} width="300.6" height="24.4" />
          </g>
          <g>
            <g>
              <g>
                <path className={styles.st4}
                  d="M133,245.7H67.8c-0.5,0-0.8-0.4-0.8-0.8v-34.3c0-0.5,0.4-0.8,0.8-0.8H133c0.5,0,0.8,0.4,0.8,0.8v34.3C133.9,245.3,133.5,245.7,133,245.7z"
                />
              </g>
              <g>
                <path className={styles.st4}
                  d="M212.6,245.7h-65.2c-0.5,0-0.8-0.4-0.8-0.8v-34.3c0-0.5,0.4-0.8,0.8-0.8h65.2c0.5,0,0.8,0.4,0.8,0.8v34.3C213.4,245.3,213,245.7,212.6,245.7z"
                />
              </g>
              <g>
                <path className={styles.st4}
                  d="M292.1,245.7h-65.2c-0.5,0-0.8-0.4-0.8-0.8v-34.3c0-0.5,0.4-0.8,0.8-0.8h65.2c0.5,0,0.8,0.4,0.8,0.8v34.3C293,245.3,292.6,245.7,292.1,245.7z"
                />
              </g>
            </g>
            <g>
              <g>
                <path className={styles.st4}
                  d="M133,287.2H67.8c-0.5,0-0.8-0.4-0.8-0.8V252c0-0.5,0.4-0.8,0.8-0.8H133c0.5,0,0.8,0.4,0.8,0.8v34.3C133.9,286.8,133.5,287.2,133,287.2z"
                />
              </g>
              <g>
                <path className={styles.st4}
                  d="M212.6,287.2h-65.2c-0.5,0-0.8-0.4-0.8-0.8V252c0-0.5,0.4-0.8,0.8-0.8h65.2c0.5,0,0.8,0.4,0.8,0.8v34.3C213.4,286.8,213,287.2,212.6,287.2z"
                />
              </g>
              <g>
                <path className={styles.st4}
                  d="M292.1,287.2h-65.2c-0.5,0-0.8-0.4-0.8-0.8V252c0-0.5,0.4-0.8,0.8-0.8h65.2c0.5,0,0.8,0.4,0.8,0.8v34.3C293,286.8,292.6,287.2,292.1,287.2z"
                />
              </g>
            </g>
            <g>
              <g>
                <path className={styles.st4}
                  d="M133,328.7H67.8c-0.5,0-0.8-0.4-0.8-0.8v-34.3c0-0.5,0.4-0.8,0.8-0.8H133c0.5,0,0.8,0.4,0.8,0.8v34.3C133.9,328.3,133.5,328.7,133,328.7z"
                />
              </g>
              <g>
                <path className={styles.st4}
                  d="M212.6,328.7h-65.2c-0.5,0-0.8-0.4-0.8-0.8v-34.3c0-0.5,0.4-0.8,0.8-0.8h65.2c0.5,0,0.8,0.4,0.8,0.8v34.3C213.4,328.3,213,328.7,212.6,328.7z"
                />
              </g>
              <g>
                <path className={styles.st4}
                  d="M292.1,328.7h-65.2c-0.5,0-0.8-0.4-0.8-0.8v-34.3c0-0.5,0.4-0.8,0.8-0.8h65.2c0.5,0,0.8,0.4,0.8,0.8v34.3C293,328.3,292.6,328.7,292.1,328.7z"
                />
              </g>
            </g>
            <g>
              <g>
                <path className={styles.st4}
                  d="M212.6,371.5h-65.2c-0.5,0-0.8-0.4-0.8-0.8v-34.3c0-0.5,0.4-0.8,0.8-0.8h65.2c0.5,0,0.8,0.4,0.8,0.8v34.3C213.4,371.1,213,371.5,212.6,371.5z"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path className={styles.st1}
                  d="M125.5,175.6h-44c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h44c0.7,0,1.2,0.5,1.2,1.2S126.2,175.6,125.5,175.6z"
                />
              </g>
            </g>
            <g>
              <g>
                <path className={styles.st1}
                  d="M177.6,175.6h-44c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h44c0.7,0,1.2,0.5,1.2,1.2S178.2,175.6,177.6,175.6z"
                />
              </g>
            </g>
            <g>
              <g>
                <path className={styles.st1}
                  d="M229.6,175.6h-44c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h44c0.7,0,1.2,0.5,1.2,1.2S230.2,175.6,229.6,175.6z"
                />
              </g>
            </g>
            <g>
              <g>
                <path className={styles.st1}
                  d="M281.6,175.6h-44c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2h44c0.7,0,1.2,0.5,1.2,1.2S282.3,175.6,281.6,175.6z"
                />
              </g>
            </g>
          </g>
          <g>
            <path className={styles.st1}
              d="M278.1,363.3h-30.7c-0.5,0-1-0.3-1.2-0.8l-4.4-8.1c-0.3-0.6-0.3-1.3,0-1.8l4.4-8.1c0.3-0.5,0.7-0.8,1.2-0.8h30.7c0.8,0,1.5,0.8,1.5,1.7v16.3C279.5,362.6,278.9,363.3,278.1,363.3z"
            />
          </g>
          <g>
            <rect x="28.1" y="45.4" className={styles.st0} width="300.6" height="54.5" />
          </g>
          <g>
            <g>
              <path className={styles.st5}
                d="M254.3,70.9v1.5c0,0.1,0,0.3-0.1,0.4S254,73,253.8,73h-1.4v3.7h-2.3V73h-6.4c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.2-0.3-0.4l-0.3-1.3l7.2-9.7h2.5v9.5C252.3,70.9,254.3,70.9,254.3,70.9z M250.1,70.9v-5c0-0.5,0-1,0.1-1.6l-4.7,6.6H250.1z"
              />
            </g>
            <g>
              <path className={styles.st5}
                d="M256.5,67.7c0-0.2,0-0.4,0.1-0.6s0.2-0.4,0.3-0.5c0.1-0.1,0.3-0.3,0.5-0.3c0.2-0.1,0.4-0.1,0.6-0.1s0.4,0,0.6,0.1s0.4,0.2,0.5,0.3c0.1,0.1,0.3,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.6s0,0.4-0.1,0.6s-0.2,0.4-0.3,0.5c-0.1,0.1-0.3,0.3-0.5,0.3c-0.2,0.1-0.4,0.1-0.6,0.1s-0.4,0-0.6-0.1s-0.4-0.2-0.5-0.3c-0.1-0.1-0.3-0.3-0.3-0.5C256.6,68.2,256.5,67.9,256.5,67.7z M256.5,75.2c0-0.2,0-0.4,0.1-0.6s0.2-0.4,0.3-0.5c0.1-0.1,0.3-0.3,0.5-0.3c0.2-0.1,0.4-0.1,0.6-0.1s0.4,0,0.6,0.1s0.4,0.2,0.5,0.3c0.1,0.1,0.3,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.6s0,0.4-0.1,0.6s-0.2,0.4-0.3,0.5c-0.1,0.1-0.3,0.3-0.5,0.3c-0.2,0.1-0.4,0.1-0.6,0.1s-0.4,0-0.6-0.1s-0.4-0.2-0.5-0.3c-0.1-0.1-0.3-0.3-0.3-0.5C256.6,75.7,256.5,75.5,256.5,75.2z"
              />
            </g>
            <g>
              <path className={styles.st5}
                d="M273.1,69c0,1.3-0.1,2.5-0.4,3.5s-0.7,1.8-1.2,2.4s-1.1,1.1-1.8,1.4s-1.4,0.5-2.2,0.5c-0.8,0-1.5-0.2-2.2-0.5s-1.3-0.8-1.8-1.4s-0.9-1.5-1.2-2.4c-0.3-1-0.4-2.1-0.4-3.5c0-1.3,0.1-2.5,0.4-3.5s0.7-1.8,1.2-2.4s1.1-1.1,1.8-1.4c0.7-0.3,1.4-0.5,2.2-0.5c0.8,0,1.5,0.2,2.2,0.5s1.3,0.8,1.8,1.4c0.5,0.6,0.9,1.4,1.2,2.4C272.9,66.6,273.1,67.7,273.1,69z M270.4,69c0-1.1-0.1-2-0.2-2.7c-0.2-0.7-0.4-1.3-0.6-1.7c-0.3-0.4-0.6-0.7-0.9-0.9c-0.4-0.2-0.7-0.3-1.1-0.3s-0.7,0.1-1.1,0.3c-0.3,0.2-0.7,0.5-0.9,0.9c-0.3,0.4-0.5,1-0.6,1.7c-0.2,0.7-0.2,1.6-0.2,2.7s0.1,2,0.2,2.7c0.2,0.7,0.4,1.3,0.6,1.7c0.3,0.4,0.6,0.7,0.9,0.9c0.3,0.2,0.7,0.3,1.1,0.3s0.7-0.1,1.1-0.3c0.4-0.2,0.7-0.5,0.9-0.9c0.3-0.4,0.5-1,0.6-1.7C270.3,71.1,270.4,70.2,270.4,69z"
              />
            </g>
            <g>
              <path className={styles.st5}
                d="M275.3,65.7c0.1-0.7,0.3-1.4,0.6-1.9c0.3-0.6,0.7-1,1.1-1.4c0.5-0.4,1-0.6,1.6-0.8s1.2-0.3,1.9-0.3c0.7,0,1.3,0.1,1.9,0.3s1,0.5,1.4,0.8c0.4,0.4,0.7,0.8,0.9,1.3c0.2,0.5,0.3,1,0.3,1.6c0,0.5-0.1,0.9-0.2,1.3s-0.3,0.7-0.5,1s-0.5,0.5-0.8,0.7s-0.6,0.3-1,0.5c0.9,0.3,1.6,0.7,2,1.3c0.4,0.6,0.7,1.3,0.7,2.2c0,0.8-0.1,1.4-0.4,2s-0.7,1.1-1.1,1.5c-0.5,0.4-1,0.7-1.7,0.9c-0.6,0.2-1.3,0.3-2,0.3c-0.8,0-1.4-0.1-2-0.3c-0.6-0.2-1.1-0.4-1.5-0.8c-0.4-0.3-0.8-0.8-1.1-1.3c-0.3-0.5-0.5-1.1-0.8-1.7l1.2-0.5c0.3-0.1,0.6-0.2,0.8-0.1c0.3,0.1,0.5,0.2,0.6,0.4c0.1,0.2,0.3,0.5,0.4,0.7c0.2,0.2,0.3,0.5,0.5,0.6c0.2,0.2,0.5,0.3,0.7,0.5c0.3,0.1,0.6,0.2,1,0.2s0.8-0.1,1.2-0.2c0.3-0.1,0.6-0.3,0.8-0.6s0.4-0.5,0.5-0.8s0.2-0.6,0.2-0.9c0-0.4,0-0.7-0.1-1s-0.2-0.6-0.5-0.8c-0.2-0.2-0.6-0.4-1.1-0.5s-1.1-0.2-1.9-0.2v-1.9c0.6,0,1.2-0.1,1.6-0.2s0.8-0.3,1-0.5s0.4-0.4,0.5-0.7s0.1-0.6,0.1-0.9c0-0.7-0.2-1.3-0.6-1.6c-0.4-0.4-0.9-0.6-1.6-0.6c-0.3,0-0.6,0-0.9,0.1s-0.5,0.2-0.7,0.4s-0.4,0.3-0.5,0.6c-0.1,0.2-0.2,0.4-0.3,0.7c-0.1,0.3-0.3,0.5-0.5,0.6s-0.5,0.1-0.8,0.1L275.3,65.7z"
              />
            </g>
            <g>
              <path className={styles.st5}
                d="M293.6,61.4c1,0,1.9,0.1,2.6,0.4s1.4,0.6,1.8,1c0.5,0.4,0.8,0.9,1.1,1.5c0.2,0.6,0.4,1.3,0.4,2s-0.1,1.4-0.4,2c-0.2,0.6-0.6,1.1-1.1,1.6c-0.5,0.4-1.1,0.8-1.9,1c-0.7,0.2-1.6,0.4-2.6,0.4h-2.1v5.4h-2.8V61.4H293.6zM293.6,69.1c0.5,0,1-0.1,1.4-0.2s0.7-0.3,1-0.6c0.3-0.2,0.4-0.5,0.6-0.9c0.1-0.3,0.2-0.7,0.2-1.2c0-0.4-0.1-0.8-0.2-1.1c-0.1-0.3-0.3-0.6-0.6-0.8c-0.3-0.2-0.6-0.4-1-0.5s-0.8-0.2-1.4-0.2h-2.1v5.5C291.5,69.1,293.6,69.1,293.6,69.1z"
              />
            </g>
            <g>
              <path className={styles.st5}
                d="M318.7,61.4v15.3h-2.5v-9.9c0-0.4,0-0.8,0.1-1.3l-4.6,8.7c-0.2,0.4-0.6,0.6-1,0.6h-0.4c-0.5,0-0.8-0.2-1-0.6l-4.7-8.7c0,0.2,0,0.5,0.1,0.7c0,0.2,0,0.4,0,0.6v9.9h-2.5V61.4h2.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.3l4.6,8.5c0.1,0.2,0.2,0.5,0.3,0.7c0.1,0.2,0.2,0.5,0.3,0.7c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.2,0.2-0.5,0.3-0.7l4.5-8.5c0.1-0.1,0.1-0.2,0.2-0.3s0.1-0.1,0.2-0.1s0.2,0,0.2-0.1c0.1,0,0.2,0,0.3,0h2.3V61.4z"
              />
            </g>
          </g>
          <g>
            <g>
              <path className={styles.st1}
                d="M255.9,83.9V90h-1v-3.9c0-0.2,0-0.3,0-0.5L253,89c-0.1,0.2-0.2,0.2-0.4,0.2h-0.2c-0.2,0-0.3-0.1-0.4-0.2l-1.9-3.5c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2v4h-1v-6.1h0.9c0.1,0,0.1,0,0.1,0h0.1c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0.1,0.1l1.8,3.4c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.3c0-0.1,0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3l1.8-3.4c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1h0.1h0.1H255.9z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M259.1,85.6c0.3,0,0.6,0.1,0.9,0.2s0.5,0.3,0.7,0.4c0.2,0.2,0.3,0.4,0.4,0.7c0.1,0.3,0.2,0.6,0.2,0.9s-0.1,0.7-0.2,0.9c-0.1,0.3-0.2,0.5-0.4,0.7s-0.4,0.3-0.7,0.4c-0.3,0.1-0.6,0.2-0.9,0.2s-0.6-0.1-0.9-0.2s-0.5-0.3-0.7-0.4s-0.3-0.4-0.4-0.7c-0.1-0.3-0.2-0.6-0.2-0.9s0.1-0.6,0.2-0.9s0.2-0.5,0.4-0.7c0.2-0.2,0.4-0.3,0.7-0.4S258.7,85.6,259.1,85.6zM259.1,89.3c0.4,0,0.6-0.1,0.8-0.4c0.2-0.2,0.3-0.6,0.3-1.1s-0.1-0.8-0.3-1.1c-0.2-0.2-0.4-0.4-0.8-0.4s-0.6,0.1-0.8,0.4c-0.2,0.2-0.3,0.6-0.3,1.1s0.1,0.8,0.3,1.1C258.4,89.2,258.7,89.3,259.1,89.3z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M263.2,86.2c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.3,0,0.4,0c0.2,0,0.4,0,0.6,0.1s0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.7V90h-1v-2.8c0-0.3-0.1-0.5-0.2-0.6s-0.3-0.2-0.6-0.2c-0.2,0-0.3,0-0.5,0.1s-0.3,0.2-0.4,0.3V90h-1v-4.3h0.6c0.1,0,0.2,0.1,0.3,0.2L263.2,86.2z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M270.9,83.7V90h-0.6c-0.1,0-0.2-0.1-0.3-0.2l-0.1-0.4c-0.2,0.2-0.4,0.4-0.6,0.5s-0.5,0.2-0.8,0.2c-0.2,0-0.5,0-0.7-0.1s-0.4-0.2-0.5-0.4c-0.1-0.2-0.3-0.4-0.3-0.7c-0.1-0.3-0.1-0.6-0.1-0.9s0-0.6,0.1-0.9s0.2-0.5,0.4-0.7c0.2-0.2,0.4-0.4,0.6-0.5s0.5-0.2,0.8-0.2c0.2,0,0.4,0,0.6,0.1s0.3,0.2,0.5,0.3v-2.3h1V83.7z M269.9,86.8c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.4,0.1s-0.2,0.1-0.3,0.3c-0.1,0.1-0.2,0.3-0.2,0.5s-0.1,0.4-0.1,0.7c0,0.3,0,0.5,0.1,0.6c0,0.2,0.1,0.3,0.2,0.4s0.2,0.2,0.3,0.2c0.1,0,0.2,0.1,0.4,0.1c0.2,0,0.4,0,0.6-0.1s0.3-0.2,0.4-0.4v-2H269.9z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M272.1,86.3c0.5-0.5,1.1-0.7,1.8-0.7c0.3,0,0.5,0,0.7,0.1s0.4,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.7V90H275c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.2l-0.1-0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4,0c-0.2,0-0.4,0-0.5-0.1c-0.2,0-0.3-0.1-0.4-0.2s-0.2-0.2-0.3-0.4c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3s0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.2,0.5-0.2c0.2-0.1,0.4-0.1,0.7-0.2c0.3,0,0.5-0.1,0.9-0.1v-0.3c0-0.3-0.1-0.5-0.2-0.6s-0.3-0.2-0.5-0.2s-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.1s-0.2,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1s-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.1L272.1,86.3zM274.5,88.2c-0.3,0-0.6,0-0.8,0.1c-0.2,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.2,0.1,0.3,0.2,0.4s0.2,0.1,0.4,0.1c0.2,0,0.4,0,0.6-0.1s0.3-0.2,0.5-0.4L274.5,88.2L274.5,88.2z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M280.5,85.7l-2.4,5.5c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1H277l0.8-1.7l-1.8-4h0.9c0.1,0,0.1,0,0.2,0.1l0.1,0.1l0.9,2.2c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2,0.1,0.2c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2l0.9-2.2c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1L280.5,85.7L280.5,85.7z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M286.9,89c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.1,0.1,0.3V90h-4.2v-0.3c0-0.1,0-0.1,0-0.2s0.1-0.1,0.1-0.2l1.9-1.9c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.3,0.2-0.4c0-0.1,0.1-0.3,0.1-0.5c0-0.1,0-0.3-0.1-0.4c0-0.1-0.1-0.2-0.2-0.3s-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.1,0.1-0.2,0.2s-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.2,0.1-0.3,0l-0.5-0.1c0-0.3,0.1-0.6,0.2-0.8c0.1-0.2,0.3-0.4,0.5-0.6c0.2-0.1,0.4-0.3,0.6-0.3c0.2-0.1,0.5-0.1,0.8-0.1s0.5,0,0.8,0.1c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.3,0.4,0.5s0.1,0.5,0.1,0.7s0,0.4-0.1,0.6s-0.2,0.4-0.3,0.5s-0.2,0.3-0.4,0.5c-0.1,0.2-0.3,0.3-0.5,0.5l-1.4,1.4c0.1,0,0.3-0.1,0.4-0.1s0.3,0,0.4,0h1.6V89z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M292.5,87c0,0.5-0.1,1-0.2,1.4s-0.3,0.7-0.5,1s-0.4,0.4-0.7,0.6c-0.3,0.1-0.6,0.2-0.9,0.2s-0.6-0.1-0.9-0.2s-0.5-0.3-0.7-0.6c-0.2-0.3-0.4-0.6-0.5-1s-0.2-0.9-0.2-1.4s0.1-1,0.2-1.4s0.3-0.7,0.5-1s0.4-0.4,0.7-0.6c0.3-0.1,0.6-0.2,0.9-0.2s0.6,0.1,0.9,0.2s0.5,0.3,0.7,0.6c0.2,0.3,0.4,0.6,0.5,1C292.5,86,292.5,86.4,292.5,87z M291.5,87c0-0.4,0-0.8-0.1-1.1c-0.1-0.3-0.2-0.5-0.3-0.7c-0.1-0.2-0.2-0.3-0.4-0.4c-0.1-0.1-0.3-0.1-0.4-0.1s-0.3,0-0.4,0.1s-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.4-0.3,0.7c-0.1,0.3-0.1,0.7-0.1,1.1s0,0.8,0.1,1.1c0.1,0.3,0.1,0.5,0.3,0.7c0.1,0.2,0.2,0.3,0.4,0.4c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.3,0,0.4-0.1s0.3-0.2,0.4-0.4c0.1-0.2,0.2-0.4,0.3-0.7C291.4,87.8,291.5,87.4,291.5,87z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M294.9,90.1c-0.4,0-0.7-0.1-0.9-0.3c-0.2-0.2-0.3-0.5-0.3-0.9v-2.4h-0.4c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.2v-0.4l0.7-0.1l0.2-1.2c0-0.1,0-0.1,0.1-0.1c0,0,0.1,0,0.2,0h0.5v1.4h1.2v0.7h-1.2v2.3c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0h0.1h0.1h0.1h0.1c0,0,0,0,0.1,0.1l0.3,0.5c-0.2,0.1-0.3,0.2-0.5,0.3C295.3,90,295.1,90.1,294.9,90.1z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M297.9,86.1c0.2-0.2,0.4-0.3,0.6-0.4s0.4-0.1,0.7-0.1c0.2,0,0.4,0,0.6,0.1s0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.7V90h-1v-2.8c0-0.3-0.1-0.5-0.2-0.6s-0.3-0.2-0.6-0.2c-0.2,0-0.3,0-0.5,0.1s-0.3,0.2-0.4,0.3V90h-1v-6.3h1v2.4H297.9z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M309.2,90h-0.9c-0.1,0-0.2,0-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.2l-0.5-1.2H305l-0.5,1.2c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1h-0.9l2.4-6.1h1.2L309.2,90z M307.2,87.7l-0.7-2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.3-0.1-0.4c0,0.1-0.1,0.3-0.1,0.4s-0.1,0.2-0.1,0.3l-0.7,2H307.2z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M310.8,86.3c0.2-0.2,0.4-0.4,0.6-0.5s0.5-0.2,0.8-0.2c0.2,0,0.5,0,0.6,0.1s0.4,0.2,0.5,0.4c0.1,0.2,0.3,0.4,0.3,0.7c0.1,0.3,0.1,0.6,0.1,0.9s0,0.6-0.1,0.9s-0.2,0.5-0.4,0.7s-0.4,0.4-0.6,0.5s-0.5,0.2-0.8,0.2c-0.2,0-0.4,0-0.6-0.1s-0.3-0.2-0.5-0.3v1.8h-1v-5.7h0.6c0.1,0,0.2,0.1,0.3,0.2L310.8,86.3z M310.9,88.9c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.1s0.3,0,0.4-0.1s0.2-0.1,0.3-0.3c0.1-0.1,0.2-0.3,0.2-0.5s0.1-0.4,0.1-0.7c0-0.3,0-0.5-0.1-0.6c0-0.2-0.1-0.3-0.2-0.4s-0.2-0.2-0.3-0.2c-0.1-0.1-0.2-0.1-0.4-0.1c-0.2,0-0.4,0-0.6,0.1s-0.3,0.2-0.4,0.4v2H310.9z"
              />
            </g>
            <g>
              <path className={styles.st1}
                d="M315.8,86.4c0.1-0.3,0.3-0.5,0.5-0.6s0.4-0.2,0.7-0.2c0.2,0,0.4,0,0.5,0.1l-0.1,0.8c0,0.1,0,0.1-0.1,0.1h-0.1c0,0-0.1,0-0.2,0s-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.2,0.2s-0.1,0.2-0.2,0.3V90h-1v-4.3h0.6c0.1,0,0.2,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2L315.8,86.4z"
              />
            </g>
          </g>
          <g>
            <g>
              <path className={styles.st1}
                d="M57.6,67.4h-5.3c0,0-0.6,0.2-0.7,0.9l-1.3,15.3c0,0,0,1.1-0.7,1.1H46c0,0-0.7,0-0.6-1l1.3-15.2c0,0,0.1-1-0.8-1h-5.2c0,0-0.8,0.1-0.7-1l0.2-2c0,0,0-0.9,1-0.9h16.5c0,0,0.9,0,0.9,0.4l-0.2,2.7C58.5,66.7,58.4,67.4,57.6,67.4zM75.6,83.4c0,0,0.4,1.2-0.6,1.3h-3.4c0,0-0.8,0-1-0.9l-1-3.3c0,0-0.2-0.4-1-0.5h-6.8c0,0-0.8,0-1.1,0.7L59.1,84c0,0-0.3,0.6-1.2,0.7h-3.1c0,0-0.7,0-0.6-0.6l9.6-19.6c0,0,0.3-0.7,0.9-0.7h0.9h3c0,0,0.6,0,0.9,0.6L75.6,83.4z M68.2,75.5L66.5,70c-0.2-0.5-0.4-0.5-0.4-0.5c-0.4,0-0.5,0.3-0.5,0.3l-2.7,5.9c-0.3,0.7,0.5,0.8,0.5,0.8h4.1C68.5,76.5,68.2,75.5,68.2,75.5z M141.9,84.7h-3.4c0,0-0.8,0-1-0.9l-1-3.3c0,0-0.2-0.4-1-0.5h-6.8c0,0-0.8,0-1.1,0.7L126,84c0,0-0.3,0.6-1.2,0.7h-3.1c0,0-0.7,0-0.6-0.6l9.6-19.6c0,0,0.3-0.7,0.9-0.7h0.9h3c0,0,0.6,0,0.9,0.6l6.2,19.1C142.4,83.4,142.9,84.6,141.9,84.7z M135,75.5l-1.7-5.5c-0.2-0.5-0.4-0.5-0.4-0.5c-0.4,0-0.5,0.3-0.5,0.3l-2.7,5.9c-0.3,0.7,0.5,0.8,0.5,0.8h4.1C135.4,76.5,135,75.5,135,75.5z M78.4,83.9c0,0.7,0.7,0.8,0.7,0.8h3.2c0.7,0,0.8-0.6,0.8-0.6l0.8-10.3l-4.2-6.9L78.4,83.9z M98.2,61.9h-2.9c-0.9,0-0.9,0.9-0.9,0.9l-0.9,13.3c0,0.4-0.1,0.6-0.2,0.7s-0.2,0.1-0.3,0.1c-0.3-0.1-0.5-0.5-0.5-0.5l-7.1-11.8c-0.5-1-1.1-0.9-1.1-0.9h-3.6c-0.4,0-0.6,0.3-0.6,0.3l12,19.9c0.2,0.4,0.6,0.6,0.8,0.7c0.1,0,0.3,0.1,0.3,0.1h3.4c0.9-0.1,0.9-0.7,0.9-0.7L99,62.5C98.9,61.9,98.2,61.9,98.2,61.9z M120.3,79.5c0,0-2.5,5.5-9.5,5.2h-8.5h-0.5c0,0-0.9,0-0.8-1.1l1.3-19.1c0,0,0-0.8,0.9-0.8h9.1c0,0,5-0.1,7.6,3.3c0.2,0.3,0.7,1.2,0.9,1.6C121.6,70.1,122.8,74.1,120.3,79.5z M116.8,72.4c0-0.3-0.1-0.9-0.2-1.1c-1-3.8-5.1-3.8-5.1-3.8h-3.3c-1.2,0.1-1.1,0.7-1.1,0.7l-0.7,11.6c-0.1,1.1,0.9,1.1,0.9,1.1h3.9c0.3,0,1.4-0.2,1.4-0.2C117,79.5,116.9,74.1,116.8,72.4z"
              />
            </g>
          </g>
          <g>
            <path className={styles.st1}
              d="M119,363.3H81.8c-0.9,0-1.6-0.7-1.6-1.6V349c0-0.9,0.7-1.6,1.6-1.6H119c0.9,0,1.6,0.7,1.6,1.6v12.7C120.6,362.6,119.9,363.3,119,363.3z"
            />
          </g>
          <g>
            <path className={styles.st1}
              d="M209.7,34.9h-63.2c-0.8,0-1.5-0.7-1.5-1.5v-4.2c0-0.8,0.7-1.5,1.5-1.5h63.2c0.8,0,1.5,0.7,1.5,1.5v4.2C211.2,34.3,210.5,34.9,209.7,34.9z"
            />
          </g>
          <path className={styles.st6}
            d="M350,84h-2.1V15.9c0-5.5-4.4-9.9-9.9-9.9H18.9C13.4,6,9,10.4,9,15.9V84H6.8c-0.3,0-0.5,0.2-0.5,0.5v40.2c0,0.3,0.2,0.5,0.5,0.5H9v10.1H6.8c-0.3,0-0.5,0.2-0.5,0.5V176c0,0.3,0.2,0.5,0.5,0.5H9v306c0,5.5,4.4,9.9,9.9,9.9H338c5.5,0,9.9-4.4,9.9-9.9V133.9h2.1c0.3,0,0.5-0.2,0.5-0.5V84.5C350.5,84.2,350.2,84,350,84z"
          />
          <text transform="matrix(1 0 0 1 92.0495 236.0143)" className={cn(styles.st1, styles.st7, styles.st8)}>1</text>
          <text transform="matrix(1 0 0 1 173.0232 236.0143)" className={cn(styles.st1, styles.st7, styles.st8)}>2</text>
          <text transform="matrix(1 0 0 1 251.3303 236.0143)" className={cn(styles.st1, styles.st7, styles.st8)}>3</text>
          <text transform="matrix(1 0 0 1 92.0495 277.5768)" className={cn(styles.st1, styles.st7, styles.st8)}>4</text>
          <text transform="matrix(1 0 0 1 173.0232 277.5768)" className={cn(styles.st1, styles.st7, styles.st8)}>5</text>
          <text transform="matrix(1 0 0 1 252.0989 277.5768)" className={cn(styles.st1, styles.st7, styles.st8)}>6</text>
          <text transform="matrix(1 0 0 1 92.0495 319.1393)" className={cn(styles.st1, styles.st7, styles.st8)}>7</text>
          <text transform="matrix(1 0 0 1 173.0232 319.1393)" className={cn(styles.st1, styles.st7, styles.st8)}>8</text>
          <text transform="matrix(1 0 0 1 173.0232 361.5123)" className={cn(styles.st1, styles.st7, styles.st8)}>0</text>
          <text transform="matrix(1 0 0 1 253.9973 319.1393)" className={cn(styles.st1, styles.st7, styles.st8)}>9</text>
          <g>
            <text transform="matrix(1 0 0 1 98.3279 156.2252)" className={cn(styles.st1, styles.st7, styles.st9)}>7</text>
          </g>
          <g>
            <text transform="matrix(1 0 0 1 151.1677 156.2252)" className={cn(styles.st1, styles.st7, styles.st9)}>3</text>
          </g>
          <g>
            <text transform="matrix(1 0 0 1 201.4704 156.2252)" className={cn(styles.st1, styles.st7, styles.st9)}>5</text>
          </g>
          <g>
            <text transform="matrix(1 0 0 1 254.3259 156.2252)" className={cn(styles.st1, styles.st7, styles.st9)}>0</text>
          </g>
        </g>
        </svg>
      </div>
    );
  }
}

IpadAnimated.propTypes = {
  className: PropTypes.string,
};

export default IpadAnimated;



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_carousel/shared/ipad-animated/index.jsx